import React from 'react';
import CollapsibleSection from '../Common/CollapsibleSection';
import './BiographySection.css';

interface BiographySectionProps {
  title: string;
  children: React.ReactNode;
  sectionId: string;
  defaultExpanded?: boolean;
  priority?: 'high' | 'medium' | 'low';
  icon?: React.ReactNode;
  isEmpty?: boolean;
  emptyMessage?: string;
  headerActions?: React.ReactNode;
}

const BiographySection: React.FC<BiographySectionProps> = (props) => {
  return (
    <CollapsibleSection
      {...props}
      className="biography-section"
    />
  );
};

export default BiographySection;